import { lazy, Suspense, useEffect } from "react";
import { LazyMotion, domAnimation } from "framer-motion";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Footer from "@/components/Footer";
import FloatingContact from "@/components/FloatingContact";
import OfferPopup from "@/components/OfferPopup";

const Manifesto = lazy(() => import("@/components/Manifesto"));
const Reviews = lazy(() => import("@/components/Reviews"));
const BookingForm = lazy(() => import("@/components/BookingForm"));
const LocationSection = lazy(() => import("@/components/LocationSection"));

const NOISE =
  "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

function App() {
  useEffect(() => {
    let lenis = null;
    let rafId = null;
    let cancelled = false;
    import("lenis").then(({ default: Lenis }) => {
      if (cancelled) return;
      lenis = new Lenis({ duration: 1.2, smoothWheel: true });
      window.__lenis = lenis;
      const raf = (time) => {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
      };
      rafId = requestAnimationFrame(raf);
    });
    return () => {
      cancelled = true;
      if (rafId) cancelAnimationFrame(rafId);
      if (lenis) lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LazyMotion features={domAnimation} strict>
      <div className="min-h-screen bg-plum-950 font-sans text-cream">
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 z-[60] opacity-[0.05] mix-blend-overlay"
        style={{ backgroundImage: NOISE }}
      />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Suspense fallback={null}>
          <Manifesto />
          <Reviews />
          <BookingForm />
          <LocationSection />
        </Suspense>
      </main>
      <Footer />
      <FloatingContact />
      <OfferPopup />
      </div>
    </LazyMotion>
  );
}

export default App;
